<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <SectionTitle :title="label('title')"/>
      </v-col>
    </v-row>
    <v-row>
      <FormItem :name="label('dataType')">
        <SelectField
            v-model="dataGoodAt"
            :name="label('dataType')"
            :items="dataGoodAtItems"
            multi
            :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('task')">
        <SelectField
                v-model="taskGoodAt"
                :name="label('task')"
                :items="taskGoodAtItems"
                multi
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('domain')">
        <TextField
            v-model="domainGoodAt"
            :name="label('domain')"
            :max="255"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('programming')">
        <SelectField
                v-model="programming"
                :name="label('programming')"
                :items="programmings"
                multi
                :submit="submit"
        />
      </FormItem>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from "../atoms/SectionTitle";
  import FormItem from "../molecules/FormItem";
  import SelectField from "../atoms/SelectField";
  import ComponentMixin from "../ComponentMixin";
  import {mapGetters} from "vuex";
  import TextField from "@/components/atoms/TextField";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "ProfileAdditionalForm",
    props: {
      "value": {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      dataGoodAt: {
        get () {
          return this.value.dataGoodAt
        },
        set (value) {
          this.$emit("input", {...this.value, dataGoodAt: value})
        }
      },
      programming: {
        get () {
          return this.value.programmingLanguage
        },
        set (value) {
          this.$emit("input", {...this.value, programmingLanguage: value})
        }
      },
      taskGoodAt: {
        get () {
          return this.value.taskGoodAt
        },
        set (value) {
          this.$emit("input", {...this.value, taskGoodAt: value})
        }
      },
      domainGoodAt: {
        get () {
          return this.value.domainGoodAt
        },
        set (value) {
          this.$emit("input", {...this.value, domainGoodAt: value})
        }
      },
      dataGoodAtItems () {
        return this.consts.dataGoodAt
      },
      taskGoodAtItems () {
        return this.consts.taskGoodAt
      },
      programmings () {
        return this.consts.programmingLanguages
      },
      domainGoodAtItems () {
        return this.consts.domainGoodAt
      }
    },
    methods: {
      submit () {
      }
    },
    components: {
      TextField,
      SectionTitle,
      FormItem,
      SelectField,
    }
  }
</script>

<style scoped>

</style>